export default __webpack_public_path__ + "static/media/casco-obrero.651a5950.png";